import { useState } from "react";
import { Outlet, useNavigate, useLocation } from "react-router-dom";
import { AppBar, Toolbar, Typography, Button, Box, Menu, MenuItem } from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { useAuth } from "../context/AuthContext";

const navItems = [
  { type: "link", label: "Dashboard", path: "/admin" },
  {
    type: "group",
    label: "Online Prelim Form Email",
    items: [
      { label: "Online Prelim Form Email Blast", path: "/admin/blast-email" },
      { label: "PT Access to Online Preliminary Form", path: "/admin/access-levels-test" }
    ]
  },
  {
    type: "group",
    label: "Submission",
    items: [
      { label: "Submissions", path: "/admin/submissions" },
      { label: "Tax Bill Description Request", path: "/admin/description-request" },
      { label: "Reports", path: "/admin/reports?category=submission" }
    ]
  },
  {
    type: "group",
    label: "Agreement & Signer",
    items: [
      {
        label: "Authorized Signer & Parent Jurisdiction Groups Management",
        path: "/admin/authorized-signer"
      },
      { label: "Agreement Workflow & Routing for Adobe Sign", path: "/admin/agreement-recipients" },
      { label: "Reports", path: "/admin/reports?category=agreement" }
    ]
  },
  {
    type: "group",
    label: "Annual Setup",
    items: [
      { label: "Submission Period Configuration", path: "/admin/submission-period" },
      { label: "Archive Process", path: "/admin/archive-process" }
    ]
  },
  { type: "link", label: "Admin Users", path: "/admin/users" }
];

function NavDropdown({ label, items }) {
  const navigate = useNavigate();
  const location = useLocation();
  const [anchor, setAnchor] = useState(null);
  const active = items.some((i) => location.pathname === i.path);

  return (
    <>
      <Button
        color="inherit"
        onClick={(e) => setAnchor(e.currentTarget)}
        endIcon={<KeyboardArrowDownIcon />}
        sx={{
          fontWeight: active ? 700 : 400,
          borderBottom: active ? "2px solid white" : "2px solid transparent",
          borderRadius: 0,
          px: 2,
          "&:hover": { borderBottom: "2px solid white" }
        }}
      >
        {label}
      </Button>
      <Menu anchorEl={anchor} open={Boolean(anchor)} onClose={() => setAnchor(null)}>
        {items.map((item) => (
          <MenuItem
            key={item.path}
            selected={location.pathname === item.path}
            onClick={() => {
              navigate(item.path);
              setAnchor(null);
            }}
          >
            {item.label}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
}

export default function AdminLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <Box sx={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>
      <AppBar position="static" color="primary" elevation={2}>
        <Toolbar sx={{ gap: 2 }}>
          <Typography variant="h6" sx={{ fontWeight: 700, mr: 3 }}>
            Direct Charges Admin
          </Typography>

          <Box sx={{ display: "flex", gap: 1 }}>
            {navItems.map((item) =>
              item.type === "group" ? (
                <NavDropdown key={item.label} label={item.label} items={item.items} />
              ) : (
                <Button
                  key={item.path}
                  color="inherit"
                  onClick={() => navigate(item.path)}
                  sx={{
                    fontWeight: location.pathname === item.path ? 700 : 400,
                    borderBottom:
                      location.pathname === item.path ? "2px solid white" : "2px solid transparent",
                    borderRadius: 0,
                    px: 2,
                    "&:hover": {
                      borderBottom: "2px solid white"
                    }
                  }}
                >
                  {item.label}
                </Button>
              )
            )}
          </Box>

          <Box sx={{ ml: "auto", display: "flex", alignItems: "center", gap: 2 }}>
            <Typography variant="body2">{user?.name || user?.username}</Typography>
            <Button color="inherit" variant="outlined" size="small" onClick={logout}>
              Logout
            </Button>
          </Box>
        </Toolbar>
      </AppBar>

      <Box sx={{ flex: 1, px: 3, py: 3 }}>
        <Outlet />
      </Box>
    </Box>
  );
}
